/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfblinkedbutnopage6Inputs */

const en_crosspostinghelpfblinkedbutnopage6 = /** @type {(inputs: Crosspostinghelpfblinkedbutnopage6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If Facebook says "user linked" but you still get an error on the way back, the app connected without access to any Page - the Page wasn't selected in Meta's dialog. Reconnect and make sure your Page is ticked.`)
};

const de_crosspostinghelpfblinkedbutnopage6 = /** @type {(inputs: Crosspostinghelpfblinkedbutnopage6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Facebook „Benutzer verknüpft“ meldet, aber beim Zurückleiten trotzdem ein Fehler kommt, wurde die App ohne Zugriff auf eine Seite verbunden – die Seite wurde im Meta-Dialog nicht ausgewählt. Neu verbinden und darauf achten, dass deine Seite angehakt ist.`)
};

/**
* | output |
* | --- |
* | "If Facebook says \"user linked\" but you still get an error on the way back, the app connected without access to any Page - the Page wasn't selected in Meta's ..." |
*
* @param {Crosspostinghelpfblinkedbutnopage6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfblinkedbutnopage6 = /** @type {((inputs?: Crosspostinghelpfblinkedbutnopage6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfblinkedbutnopage6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfblinkedbutnopage6(inputs)
	return de_crosspostinghelpfblinkedbutnopage6(inputs)
});
export { crosspostinghelpfblinkedbutnopage6 as "crosspostingHelpFbLinkedButNoPage" }